export type CustomerInteraction =
  | {
      inform: {
        qr: {
          content: string;
          img: string | null;
        };
      };
      type: 'inform';
    }
  | {
      redirect: {
        baseUrl: string;
        method: 'GET' | 'POST';
        url: string;

        params?: null | Record<string, string> | never[];
        qs?: null | Record<string, string>;
      };
      type: 'redirect';
    };

type InteractionCreator = (interaction: CustomerInteraction) => string | void;

export const createInteraction: InteractionCreator = (interaction) => {
  if (interaction.type === 'inform') {
    const {
      inform: {
        qr: { content },
      },
    } = interaction;

    return content;
  }

  if (interaction.type === 'redirect') {
    const {
      redirect: { method = 'get', params, qs, url },
    } = interaction;

    const normalizedMethod = method.toLowerCase();

    const form = document.createElement('form');

    form.action = url;
    form.method = normalizedMethod;
    form.style.cssText = `
      width: 0;
      height: 0;
      position: absolute;
      z-index: -1;
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
    `;

    Object.entries((normalizedMethod === 'post' ? params : qs) || {}).forEach(
      ([name, value]) => {
        form.insertAdjacentHTML(
          'beforeend',
          `<input name="${name}" type="hidden" value="${value}" />`,
        );
      },
    );

    document.body.appendChild(form);

    form.submit();
  }
};
